module.exports = __webpack_public_path__ + "static/media/fiat_logo.54df9ca6.png";